export type DotPattern = [string] | [string, string, string];

export const getDotPattern = (statusKebabLowerCase: string): DotPattern => {
  switch (statusKebabLowerCase) {
    case 'deal-expired':
    case 'completed':
      return ['inactive', 'inactive', statusKebabLowerCase];

    case 'pending-acceptance':
      return ['inactive', 'inactive', 'inactive'];

    case 'proposed':
    case 'live-not-spending':
      return [statusKebabLowerCase, statusKebabLowerCase, 'inactive'];

    case 'not-started':
    case 'publishing':
    case 'processing':
      return [statusKebabLowerCase, 'inactive', 'inactive'];

    default:
      return [statusKebabLowerCase];
  }
};
